<template>
  <v-card class="report-row" flat>
    <div class="row total">
      <div class="col-6">{{day.date | sloDate}}</div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="font-weight-bold">Naprava</th>
                <th class="font-weight-bold">Računi</th>
                <th class="font-weight-bold">
                  <div class="full-width text-center font-weight-bold">
                    Osnova
                  </div>
                  <div class="full-width text-center">
                    DDV
                  </div>
                </th>
                <th class="font-weight-bold">
                  <div class="full-width text-center font-weight-bold">
                    Osnova 9,5%
                  </div>
                  <div class="full-width text-center">
                    DDV 9,5%
                  </div>
                </th>
                <th class="font-weight-bold">
                  <div class="full-width text-center font-weight-bold">
                    Osnova 22%
                  </div>
                  <div class="full-width text-center">
                    DDV 22%
                  </div>
                </th>
                <th class="font-weight-bold">
                  Neobdav. promet
                </th>
                <th class="font-weight-bold">
                  Skupaj (bruto)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="device in day.devices" :key="device.name">
                <td cols="2" class="font-weight-bold">
                  {{device.name}}
                </td>
                <td>
                  {{device.minInvoiceNumber}} - {{device.maxInvoiceNumber}}
                </td>
                <td>
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxable_amount_total | price(2)">
                  </div>
                  <div class="full-width text-center" :inner-html.prop="device.tax_amount_total | price(2)">
                  </div>
                </td>
                <td>
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxLevels['9.5'].taxable_amount | price(2)" v-if="device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].taxable_amount">
                  </div>
                  <div class="full-width text-center" :inner-html.prop="device.taxLevels['9.5'].tax_amount | price(2)" v-if="device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].tax_amount">
                  </div>
                </td>
                <td>
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="device.taxLevels['22'].taxable_amount | price(2)" v-if="device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].taxable_amount">
                  </div>
                  <div class="full-width text-center" :inner-html.prop="device.taxLevels['22'].tax_amount | price(2)" v-if="device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].tax_amount">
                  </div>
                </td>
                <td>
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="nontaxableTotal(device) | price(2)" v-if="nontaxableTotal(device) !== null">
                  </div>
                  <div class="full-width text-center">
                  </div>
                </td>
                <td cols="2">
                  <div class="full-width text-right font-weight-bold" :inner-html.prop="device.total | price(2)">
                  </div>
                  <div class="full-width text-right">
                  </div>
                </td>
              </tr>
              <tr class="table-footer-daily">
                <td></td>
                <td class="font-weight-bold">
                  SKUPAJ
                </td>
                <td>
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesTaxable_amount_total(day.devices) | price(2)">
                  </div>
                  <div class="full-width text-center" :inner-html.prop="devicesTax_amount_total(day.devices) | price(2)">
                  </div>
                </td>
                <td>
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesTaxLevels95(day.devices).taxable_amount | price(2)" v-if="devicesTaxLevels95(day.devices)">
                  </div>
                  <div class="full-width text-center" :inner-html.prop="devicesTaxLevels95(day.devices).tax_amount | price(2)" v-if="devicesTaxLevels95(day.devices)">
                  </div>
                </td>
                <td>
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesTaxLevels22(day.devices).taxable_amount | price(2)" v-if="devicesTaxLevels22(day.devices)">
                  </div>
                  <div class="full-width text-center" :inner-html.prop="devicesTaxLevels22(day.devices).tax_amount | price(2)" v-if="devicesTaxLevels22(day.devices)">
                  </div>
                </td>
                <td style="padding-right: 30px;">
                  <div class="full-width text-center font-weight-bold" :inner-html.prop="devicesNontaxableTotal(day.devices) | price(2)" v-if="devicesNontaxableTotal(day.devices) !== null">
                  </div>
                  <div class="full-width text-center">
                  </div>
                </td>
                <td cols="2" class="text-right font-weight-bold" :inner-html.prop="devicesTotal(day.devices) | price(2)">
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    day: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      taxLevelsOpen: false
    }
  },
  methods: {
    sloDate (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    devicesTaxable_amount_total (devices) {
      return Object.values(devices).reduce((total, device) => total + device.taxable_amount_total, 0)
    },
    devicesTaxLevels95 (devices) {
      const taxAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].tax_amount ? device.taxLevels['9.5'].tax_amount : 0
        return total + taxAmount
      }, 0)
      const taxableAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['9.5'] && device.taxLevels['9.5'].taxable_amount ? device.taxLevels['9.5'].taxable_amount : 0
        return total + taxAmount
      }, 0)
      return {
        tax_amount: taxAmount,
        taxable_amount: taxableAmount
      }
    },
    devicesTaxLevels22 (devices) {
      const taxAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].tax_amount ? device.taxLevels['22'].tax_amount : 0
        return total + taxAmount
      }, 0)
      const taxableAmount = Object.values(devices).reduce((total, device) => {
        const taxAmount = device.taxLevels && device.taxLevels['22'] && device.taxLevels['22'].taxable_amount ? device.taxLevels['22'].taxable_amount : 0
        return total + taxAmount
      }, 0)
      return {
        tax_amount: taxAmount,
        taxable_amount: taxableAmount
      }
    },
    devicesTax_amount_total (devices) {
      return Object.values(devices).reduce((total, device) => total + device.tax_amount_total, 0)
    },
    devicesTotal (devices) {
      return Object.values(devices).reduce((total, device) => total + device.total, 0)
    },
    devicesNontaxableTotal (devices) {
      const taxable22 = this.devicesTaxLevels22(devices) ? this.devicesTaxLevels22(devices).taxable_amount : 0
      const taxable95 = this.devicesTaxLevels95(devices) ? this.devicesTaxLevels95(devices).taxable_amount : 0
      const nontax = this.devicesTaxable_amount_total(devices) - taxable22 - taxable95
      return nontax !== 0 ? nontax : null
    },
    nontaxableTotal (device) {
      const taxable22 = device.taxLevels['22'] ? device.taxLevels['22'].taxable_amount : 0
      const taxable95 = device.taxLevels['9.5'] ? device.taxLevels['9.5'].taxable_amount : 0
      const nontax = device.taxable_amount_total - taxable22 - taxable95
      return nontax !== 0 ? nontax : null
    }
  }
}
</script>

<style lang="scss" scoped>
.report-row {
  padding: 0 15px;
  margin: 5px;
  margin-bottom: 15px;
  font-size: 20px;

  .total {
    font-size: 30px;
    font-weight: bold;
  }
}
</style>
